const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.0429688,0,0,0.0429688,12,12)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "lock",
    transform: "matrix(1,0,0,1,-256,-256)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256,0C173.564,0.094 106.761,66.898 106.667,149.333L106.667,245.333C106.667,251.224 111.443,256 117.334,256L160,256C165.891,256 170.667,251.224 170.667,245.333L170.667,149.333C170.667,102.205 208.872,64 256,64C303.128,64 341.333,102.205 341.333,149.333L341.333,245.333C341.333,251.224 346.109,256 352,256L394.667,256C400.558,256 405.334,251.224 405.334,245.333L405.334,149.333C405.239,66.898 338.436,0.094 256,0Z",
    style: {
      fill: "rgb(69,90,100)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.667,234.667L117.333,234.667C99.66,234.667 85.333,248.994 85.333,266.667L85.333,458.667C85.333,488.122 109.211,512 138.666,512L373.333,512C402.788,512 426.666,488.122 426.666,458.667L426.666,266.667C426.667,248.994 412.34,234.667 394.667,234.667Z",
    style: {
      fill: "rgb(255,193,7)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.821,372.693C293.679,364.679 298.713,353.278 298.666,341.333C298.666,317.769 279.563,298.666 255.999,298.666C232.435,298.666 213.332,317.769 213.332,341.333C213.286,353.278 218.319,364.679 227.177,372.693L213.865,412.629C212.003,418.218 215.025,424.258 220.614,426.12C221.705,426.483 222.848,426.668 223.998,426.667L287.998,426.667C293.889,426.674 298.671,421.905 298.678,416.014C298.679,414.864 298.495,413.721 298.131,412.63L284.821,372.693Z",
    style: {
      fill: "rgb(69,90,100)",
      fillRule: "nonzero"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.0a1aa15e57dcf2e1798564bb1783bd40.svg";
export { ForwardRef as ReactComponent };